"use client";

import { Box } from "@mui/material";
import { useEffect, useState } from "react";

const INTERVAL_MS = 5000;
const FADE_MS = 1400;

/** S3 object URLs — rotating hero gallery only */
const HERO_ROTATION_IMAGES = [
  "https://storage.googleapis.com/cuo-website/Marcello+Hernandez+at+Paragon.jpg",
  "https://storage.googleapis.com/cuo-website/Chris+Distefano+at+Wilson.jpg",
  "https://storage.googleapis.com/cuo-website/Mark+Normand+at+Economy+Candy.jpg",
  "https://storage.googleapis.com/cuo-website/Leslie+Jones+at+Katz's+Deli.jpg",
  "https://storage.googleapis.com/cuo-website/Sam+Morril+at+KidSuper.jpg",
  "https://storage.googleapis.com/cuo-website/Dave+Attell+at+Zabar's.jpg",
  "https://storage.googleapis.com/cuo-website/Tommy+Brennan+at+Acme.jpg",
  "https://storage.googleapis.com/cuo-website/Chris+Redd+at+Economy+Candy.jpg",
  "https://storage.googleapis.com/cuo-website/Roy+Wood+at+Katz's.jpg",
  "https://storage.googleapis.com/cuo-website/Judy+Gold+%40+Paragon+Sports.jpg",
  "https://storage.googleapis.com/cuo-website/Jamie+Wolf+at+Paragon.jpg",
  "https://storage.googleapis.com/cuo-website/Jourdain+Fischer+at+Acme.jpg",
  "https://storage.googleapis.com/cuo-website/Matthew+Broussard.jpg",
  "https://storage.googleapis.com/cuo-website/Dan+Soder+at+Veselka.jpg",
  "https://storage.googleapis.com/cuo-website/Jeff+Arcuri+at+Acme.jpg",
  "https://storage.googleapis.com/cuo-website/Matt+Richards.jpg",
  "https://storage.googleapis.com/cuo-website/Emma+Wilman.jpg",
  "https://storage.googleapis.com/cuo-website/Liz+Glazer.jpg",
];

export default function HeroRotatingGallery() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % HERO_ROTATION_IMAGES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, []);

  useEffect(() => {
    const next = (index + 1) % HERO_ROTATION_IMAGES.length;
    const img = new Image();
    img.src = HERO_ROTATION_IMAGES[next];
  }, [index]);

  return (
    <Box
      role="img"
      aria-label="Photos from Comedy UO shows, rotating every few seconds"
      sx={{
        position: "relative",
        width: "100%",
        flex: { lg: 1 },
        /* Mobile / tablet column: fixed height; desktop row: fill hero column */
        minHeight: { xs: 320, lg: 0 },
        height: { xs: 320, lg: "100%" },
        flexShrink: { xs: 0, lg: 1 },
        maxHeight: { lg: "100%" },
        alignSelf: { lg: "stretch" },
        borderRadius: "28px",
        overflow: "hidden",
        isolation: "isolate",
        /* Portrait-flavored mask (taller ellipse) so edges fade vertically */
        WebkitMaskImage:
          "radial-gradient(ellipse 78% 92% at 50% 50%, #000 52%, transparent 100%)",
        maskImage:
          "radial-gradient(ellipse 78% 92% at 50% 50%, #000 52%, transparent 100%)",
        boxShadow:
          "0 24px 56px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.06) inset",
      }}
    >
      {HERO_ROTATION_IMAGES.map((src, i) => (
        <Box
          key={src}
          component="img"
          src={src}
          alt=""
          loading={i === 0 ? "eager" : "lazy"}
          decoding={i === 0 ? "sync" : "async"}
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center center",
            opacity: i === index ? 1 : 0,
            transition: `opacity ${FADE_MS}ms ease-in-out`,
            zIndex: 0,
          }}
        />
      ))}
      {/* Corner / edge bleed into hero background */}
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          pointerEvents: "none",
          borderRadius: "inherit",
          boxShadow:
            "inset 0 0 72px 28px rgba(8,8,10,0.55), inset 0 0 120px 48px rgba(8,8,10,0.25)",
        }}
      />
    </Box>
  );
}
